module.exports = {"updates":[{"title":"The launch of ftbcAcademy","path":"/about/updates/2018_09_03_the_launch_of_ftbcAcademy","date":"2018-09-03T00:00:00.000Z","desc":"ftbcAcademy is committed to providing an evolving set of material to help groom and develop the next generation of industry practitioners"},{"title":"Back to Fundamentals","path":"/about/updates/2018_09_30_back_to_fundamentals","date":"2018-09-30T00:00:00.000Z","desc":"Discover the underlying concepts that defines the working behind the bank's Financial Markets business line"}]}


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/updates/updates.yaml
// module id = 253
// module chunks = 213534597649335 267347237356544